<template>
  <div>
    <v-dialog v-model="dialog" persistent eager scrollable max-width="1000px">
      <v-form ref="IPCRRatingOutput" @submit.prevent>
        <v-card>
          <v-card-title dark class="dialog-header pt-5 pb-5 pl-6">
            <span>{{ action }} Rating</span>
            <v-spacer></v-spacer>
            <v-btn icon dark @click="closeD()">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>

          <v-card-text style="max-height: 700px" class="my-4">
            <v-container>
              <v-row>
                <v-col cols="12">
                  <div class="text-h6">
                    MFO : <span>{{ mfo }}</span>
                  </div>
                  <div class="text-h6">
                    Type : <span>{{ targetFor }}</span>
                  </div>
                </v-col>
                <v-col cols="12" v-if="eff_is_rated == 1">
                  <div
                    class="py-2 px-4 rounded-lg"
                    style="border: 1px solid grey"
                  >
                    <v-row class="mt-1">
                      <v-col cols="8">
                        <div class="text-subtitle-2">
                          Please enter your number of accomplishments:
                        </div>
                        <div class="mt-10">
                          <div class="text-subtitle-2">
                            You may only rate based on the ratings below:
                          </div>
                          <div>
                            Ratings:
                            <span
                              class="font-weight-bold"
                              v-for="(i, idx) in getRatingScale('E')"
                              :key="idx"
                              >{{
                                idx != getRatingScale("E").length - 1
                                  ? i + ", "
                                  : i
                              }}</span
                            >
                          </div>
                        </div>
                      </v-col>
                      <v-col cols="4">
                        <v-text-field
                          outlined
                          :disabled="!eff_is_rated"
                          label="Accomplishment"
                          dense
                          :rules="
                            eff_is_rated
                              ? [
                                  formRules.required,
                                  formRules.onlyNumberNoNegative,
                                ]
                              : []
                          "
                          type="number"
                          v-model="accomplishment"
                          class="rounded-lg"
                          color="#6DB249"
                        ></v-text-field>
                        <v-text-field
                          outlined
                          :disabled="!eff_is_rated"
                          label="Efficiency"
                          dense
                          :rules="
                            eff_is_rated
                              ? [
                                  (v) => checkRules('E', v),
                                  formRules.onlyNumberNoNegative,
                                ]
                              : []
                          "
                          type="number"
                          v-model="efficiency"
                          class="rounded-lg"
                          color="#6DB249"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </div>
                </v-col>
                <v-col cols="12" v-if="qly_is_rated == 1">
                  <div
                    class="py-2 px-4 rounded-lg"
                    style="border: 1px solid grey"
                  >
                    <v-row class="mt-1">
                      <v-col cols="8">
                        <div class="text-subtitle-2">
                          You may only rate based on the ratings below:
                        </div>
                        <div>
                          Ratings:
                          <span
                            class="font-weight-bold"
                            v-for="(i, idx) in getRatingScale('Q')"
                            :key="idx"
                            >{{
                              idx != getRatingScale("Q").length - 1
                                ? i + ", "
                                : i
                            }}</span
                          >
                        </div>
                      </v-col>
                      <v-col cols="4">
                        <v-text-field
                          outlined
                          :disabled="!qly_is_rated"
                          label="Quality"
                          dense
                          :rules="
                            qly_is_rated
                              ? [
                                  (v) => checkRules('Q', v),
                                  formRules.onlyNumberNoNegative,
                                ]
                              : []
                          "
                          type="number"
                          v-model="quality"
                          class="rounded-lg"
                          color="#6DB249"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </div>
                </v-col>
                <v-col cols="12" v-if="timeliness_is_rated == 1">
                  <div
                    class="py-2 px-4 rounded-lg"
                    style="border: 1px solid grey"
                  >
                    <v-row class="mt-1">
                      <v-col cols="8">
                        <div class="text-subtitle-2">
                          You may only rate based on the ratings below:
                        </div>
                        <div>
                          Ratings:
                          <span
                            class="font-weight-bold"
                            v-for="(i, idx) in getRatingScale('T')"
                            :key="idx"
                            >{{
                              idx != getRatingScale("T").length - 1
                                ? i + ", "
                                : i
                            }}</span
                          >
                        </div>
                      </v-col>
                      <v-col cols="4">
                        <v-text-field
                          outlined
                          :disabled="!timeliness_is_rated"
                          label="Timeliness"
                          dense
                          :rules="
                            timeliness_is_rated
                              ? [
                                  (v) => checkRules('T', v),
                                  formRules.onlyNumberNoNegative,
                                ]
                              : []
                          "
                          type="number"
                          v-model="timeliness"
                          class="rounded-lg"
                          color="#6DB249"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </div>
                </v-col>
                <v-col cols="12">
                  <v-textarea
                    outlined
                    label="Remarks"
                    dense
                    rows="5"
                    cols="10"
                    v-model="remarks"
                    class="rounded-lg"
                    color="#6DB249"
                  ></v-textarea>
                </v-col>
                <!-- <v-col cols="12">
                  <div class="d-flex justify-space-between">
                    <v-file-input
                      v-if="
                        action == 'Add'
                          ? true
                          : action == 'Update'
                          ? prevFile != null
                          : false
                      "
                      v-model="file_upload"
                      :rules="[formRules.required]"
                      accept="application/pdf"
                      outlined
                      color="#6DB249"
                      dense
                      label="Upload file attachement"
                    ></v-file-input>

                    <v-btn
                      color="primary"
                      v-if="action == 'Update' && !reuploadFile"
                      @click="viewFile()"
                      >View Attachment</v-btn
                    >
                    <v-btn
                      :color="!reuploadFile ? '#6DB249' : 'red'"
                      v-if="action == 'Update'"
                      :class="reupload ? 'ml-2' : ''"
                      outlined
                      @click="!reuploadFile ? reupload() : cancelReupload()"
                      >{{
                        !reuploadFile
                          ? "Upload New Attachment"
                          : "Cancel Reuploading"
                      }}</v-btn
                    >
                  </div>
                </v-col> -->
              </v-row>
            </v-container>
          </v-card-text>
          <v-divider></v-divider>

          <v-card-actions class="pa-5">
            <v-spacer></v-spacer>

            <v-btn color="red" outlined @click="closeD()">
              <v-icon>mdi-close-circle-outline</v-icon>
              Cancel
            </v-btn>

            <v-btn
              color="#519043"
              class="white--text"
              @click="save()"
              :disabled="isSubmitLoading"
              :loading="isSubmitLoading"
            >
              <v-icon>mdi-check-circle</v-icon>
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <fade-away-message-component
      displayType="variation2"
      v-model="fadeAwayMessage.show"
      :message="fadeAwayMessage.message"
      :header="fadeAwayMessage.header"
      :top="fadeAwayMessage.top"
      :type="fadeAwayMessage.type"
      :timeout="3000"
    ></fade-away-message-component>
  </div>
</template>

<script>
export default {
  props: {
    data: null,
    action: null,
  },

  data() {
    return {
      id: null,
      accomplishment: null,
      efficiency: null,
      quality: null,
      timeliness: null,
      file_upload: null,
      prevFile: null,
      mfo: null,
      targetFor: null,
      eff_is_rated: null,
      qly_is_rated: null,
      timeliness_is_rated: null,
      dialog: false,
      isSubmitLoading: false,
      facultyRating: null,
      facultyRatingSettings: null,
      reuploadFile: false,
      remarks: null,
      fadeAwayMessage: {
        show: false,
        type: "success",
        header: "Successfully Added!",
        message: "",
        top: 10,
      },
    };
  },
  watch: {
    data: {
      handler(data) {
        this.dialog = true;
        console.log("torate DATA", data);
        this.mfo = data.facultyRatingSettings.mfo;
        this.targetFor = data.facultyRatingSettings.target_for;
        this.facultyRating = data.facultyRating;
        this.facultyRatingSettings = data.facultyRatingSettings;
        this.eff_is_rated = data.facultyRatingSettings.eff_is_rated;
        this.qly_is_rated = data.facultyRatingSettings.qly_is_rated;
        this.timeliness_is_rated =
          data.facultyRatingSettings.timeliness_is_rated;
        this.efficiency = data.facultyRating.efficiency;
        this.accomplishment = data.facultyRating.accomplishment;
        this.quality = data.facultyRating.quality;
        this.timeliness = data.facultyRating.timeliness;
        this.remarks = data.facultyRating.remarks;
        this.$refs.IPCRRatingOutput.resetValidation();
      },

      deep: true,
    },
  },
  computed: {
    getEffRatingFormRule() {
      let valuesAllowed = [];
      if (this.facultyRatingSettings.eff_rating_scale.length == 0) {
        valuesAllowed = [1, 2, 3, 4, 5];
      } else {
        for (
          let i = 0;
          i < this.facultyRatingSettings.eff_rating_scale.length;
          i++
        ) {
          if (this.facultyRatingSettings.eff_rating_scale[i].checked) {
            valuesAllowed.push(
              this.facultyRatingSettings.eff_rating_scale[i].value
            );
          }
        }
      }
      return valuesAllowed;
    },
    getQlyRatingFormRule() {
      let valuesAllowed = [];
      if (this.facultyRatingSettings.qly_rating_scale.length == 0) {
        valuesAllowed = [1, 2, 3, 4, 5];
      } else {
        for (
          let i = 0;
          i < this.facultyRatingSettings.qly_rating_scale.length;
          i++
        ) {
          if (this.facultyRatingSettings.qly_rating_scale[i].checked) {
            valuesAllowed.push(
              this.facultyRatingSettings.qly_rating_scale[i].value
            );
          }
        }
      }
      return valuesAllowed;
    },
    getTimelinessRatingFormRule() {
      let valuesAllowed = [];
      if (this.facultyRatingSettings.timeliness_rating_scale.length == 0) {
        valuesAllowed = [1, 2, 3, 4, 5];
      } else {
        for (
          let i = 0;
          i < this.facultyRatingSettings.timeliness_rating_scale.length;
          i++
        ) {
          if (this.facultyRatingSettings.timeliness_rating_scale[i].checked) {
            valuesAllowed.push(
              this.facultyRatingSettings.timeliness_rating_scale[i].value
            );
          }
        }
      }
      return valuesAllowed;
    },
  },

  methods: {
    initialize() {},

    getRatingScale(type) {
      let valuesAllowed = [];
      if (this.facultyRatingSettings) {
        if (type == "E") {
          if (this.facultyRatingSettings.eff_rating_scale.length == 0) {
            valuesAllowed = [1, 2, 3, 4, 5];
          } else {
            for (
              let i = 0;
              i < this.facultyRatingSettings.eff_rating_scale.length;
              i++
            ) {
              if (this.facultyRatingSettings.eff_rating_scale[i].checked) {
                valuesAllowed.push(
                  this.facultyRatingSettings.eff_rating_scale[i].value
                );
              }
            }
          }
        }
        if (type == "Q") {
          if (this.facultyRatingSettings.qly_rating_scale.length == 0) {
            valuesAllowed = [1, 2, 3, 4, 5];
          } else {
            for (
              let i = 0;
              i < this.facultyRatingSettings.qly_rating_scale.length;
              i++
            ) {
              if (this.facultyRatingSettings.qly_rating_scale[i].checked) {
                valuesAllowed.push(
                  this.facultyRatingSettings.qly_rating_scale[i].value
                );
              }
            }
          }
        }
        if (type == "T") {
          if (this.facultyRatingSettings.timeliness_rating_scale.length == 0) {
            valuesAllowed = [1, 2, 3, 4, 5];
          } else {
            for (
              let i = 0;
              i < this.facultyRatingSettings.timeliness_rating_scale.length;
              i++
            ) {
              if (
                this.facultyRatingSettings.timeliness_rating_scale[i].checked
              ) {
                valuesAllowed.push(
                  this.facultyRatingSettings.timeliness_rating_scale[i].value
                );
              }
            }
          }
        }
      }

      return valuesAllowed;
    },

    checkRules(type, v) {
      if (type == "E") {
        if (this.getEffRatingFormRule.includes(parseInt(v))) {
          return true;
        } else {
          return "Rating should be in " + this.getEffRatingFormRule + " only!";
        }
      }
      if (type == "Q") {
        if (this.getQlyRatingFormRule.includes(parseInt(v))) {
          return true;
        } else {
          return "Rating should be in " + this.getQlyRatingFormRule + " only!";
        }
      }
      if (type == "T") {
        if (this.getTimelinessRatingFormRule.includes(parseInt(v))) {
          return true;
        } else {
          return (
            "Rating should be in " + this.getTimelinessRatingFormRule + " only!"
          );
        }
      }
    },
    closeD() {
      this.eventHub.$emit("closeIPCRFacultySetRatingDialog", false);
      this.initialize();
      this.isSubmitLoading = false;
      this.dialog = false;
    },

    reupload() {
      this.prevFile = this.facultyRating.attachment_filename;
      this.file_upload = null;
      this.reuploadFile = true;
    },

    cancelReupload() {
      this.prevFile = null;
      this.file_upload = null;
      this.reuploadFile = false;
    },

    viewFile() {
      let url =
        process.env.VUE_APP_SERVER +
        "/ipcr-target/previewFile/" +
        this.facultyRating.attachment_filename;

      let token = localStorage.getItem("token");
      const tab = window.open("about:blank");
      this.isLoading = true;
      fetch(url, { headers: { Authorization: `Bearer ${token}` } })
        .then((response) => response.blob())
        .then((blob) => {
          var _url = window.URL.createObjectURL(blob);

          tab.location = _url;
          tab.focus();
          this.isLoading = false;
        })
        .catch((err) => {
          console.log(err);
        });
    },

    save() {
      if (this.$refs.IPCRRatingOutput.validate()) {
        this.isSubmitLoading = true;
        let data = {
          id: this.facultyRating.id,
          efficiency: this.efficiency,
          quality: this.quality,
          timeliness: this.timeliness,
          prevFile: this.prevFile,
          accomplishment: this.accomplishment,
          remarks: this.remarks,
        };

        // if (this.file_upload) {
        //   let fd = new FormData();
        //   fd.append("data", JSON.stringify(data));
        //   fd.append("file", this.file_upload);

        //   // console.log(data);
        //   this.axiosCall("/ipcr-target/setFacultyIpcrRate", "POST", fd).then(
        //     (res) => {
        //       if (res.data.status == 200) {
        //         this.fadeAwayMessage.show = true;
        //         this.fadeAwayMessage.type = "success";
        //         this.fadeAwayMessage.header = "System Message";
        //         this.fadeAwayMessage.message = res.data.msg;
        //         this.closeD();
        //       } else {
        //         this.fadeAwayMessage.show = true;
        //         this.fadeAwayMessage.type = "error";
        //         this.fadeAwayMessage.header = "System Message";
        //         this.fadeAwayMessage.message = res.data.msg;
        //       }
        //     }
        //   );
        // } else {
        // console.log(data);
        this.axiosCall(
          "/ipcr-target/setFacultyIpcrRateNoReupload",
          "POST",
          data
        ).then((res) => {
          if (res.data.status == 200) {
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "success";
            this.fadeAwayMessage.header = "System Message";
            this.fadeAwayMessage.message = res.data.msg;
            this.closeD();
          } else {
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "error";
            this.fadeAwayMessage.header = "System Message";
            this.fadeAwayMessage.message = res.data.msg;
          }
        });
        // }
      }
    },
  },
};
</script>
